import { useEffect } from "react";
import { useRouter } from "@tanstack/react-router";
import { Loader2 } from "lucide-react";
import { Card, CardContent } from "@/components/ui/card";
import { useAuth } from "@/contexts/auth-context";

export default function AuthCallbackPage() {
  const { loading, isAuthenticated } = useAuth();
  const router = useRouter();

  useEffect(() => {
    if (loading) return;

    if (isAuthenticated) {
      router.navigate({ to: "/portfolio", replace: true });
    } else {
      window.location.replace("/login?error=authentication_failed");
    }
  }, [loading, isAuthenticated, router]);

  return (
    <div className="min-h-screen bg-background px-4 py-8">
      <div className="mx-auto flex min-h-[70vh] max-w-md items-center justify-center">
        <Card className="w-full border-border/60 bg-card/95 shadow-sm backdrop-blur">
          <CardContent className="flex flex-col items-center gap-4 p-8 text-center">
            <img
              src="/wealthscale_light.svg"
              alt="WealthScale Logo"
              width={72}
              height={72}
              className="block dark:hidden"
            />
            <img
              src="/wealthscale_dark.svg"
              alt="WealthScale Logo"
              width={72}
              height={72}
              className="hidden dark:block"
            />
            <Loader2 className="h-5 w-5 animate-spin text-primary" />
            <div className="space-y-1">
              <p className="text-base font-medium text-foreground">Connexion en cours...</p>
              <p className="text-sm text-muted-foreground">
                Vérification de ta session sécurisée.
              </p>
            </div>
          </CardContent>
        </Card>
      </div>
    </div>
  );
}
